const path = [
  {
    name: 'is',
    type: 'EQUAL',
    value: '='
  },
  {
    name: 'is not',
    type: 'NOT_EQUAL',
    value: '<>'
  },
  {
    name: 'is any value',
    type: 'EMPTY',
    value: 'EMPTY'
  },
  {
    name: 'contains',
    type: 'CONTAIN',
    value: 'LIKE'
  },
  {
    name: 'does not contain',
    type: 'NOT_CONTAIN',
    value: 'NOT LIKE'
  },
  {
    'name': 'regex matches',
    'type': 'REGEX',
    'value': '~'
  },
  {
    'name': 'regex does not match',
    'type': 'NOT_REGEX',
    'value': '!~'
  }
];

const domain = [
  {
    name: 'is',
    type: 'EQUAL',
    value: '='
  },
  {
    name: 'is not',
    type: 'NOT_EQUAL',
    value: '<>'
  },
  {
    name: 'contains',
    type: 'CONTAIN',
    value: 'LIKE'
  },
  {
    name: 'does not contain',
    type: 'NOT_CONTAIN',
    value: 'NOT LIKE'
  },
  {
    'name': 'regex matches',
    'type': 'REGEX',
    'value': '~'
  },
  {
    'name': 'regex does not match',
    'type': 'NOT_REGEX',
    'value': '!~'
  }
];

const empty = {
  name: 'is any value',
  type: 'EMPTY',
  value: 'EMPTY'
};

export {
  domain,
  empty,
  path
};



/** WEBPACK FOOTER **
 ** ./src/constants/operators.js
 **/